module.exports = __webpack_public_path__ + "img/bank-007.9318a68e.png";